import {
  requiredElement,
  maxLengthElement,
  minLengthElement,
  emailValidElement,
} from "@/services/ValidatorService";
import { reactive } from "vue";
import { i18n } from "@/i18n";

export const registerCardForm = reactive({
  email: "",
  password: "",
  confirmPassword: "",
  firstName: "",
  lastName: "",
  secondLastName: "",
});
export const registerCardProps = {
  email: {
    type: "email",
  },
  password: {
    type: "password",
    autocomplete: "off",
    "show-password": true,
  },
  confirmPassword: {
    type: "password",
    autocomplete: "off",
    "show-password": true,
  },
  firstName: {
    type: "text",
  },
  lastName: {
    type: "text",
  },
  secondLastName: {
    type: "text",
  },
};
export const registerCardRules = reactive({
  name: [requiredElement, maxLengthElement(50)],
  email: [requiredElement, emailValidElement],
  password: [requiredElement, minLengthElement(8)],
  confirmPassword: [
    requiredElement,
    minLengthElement(8),
    { validator: validatePass2, trigger: "blur" },
  ],
  firstName: [requiredElement],
  lastName: [requiredElement],
  secondLastName: [requiredElement],
});

function validatePass2(rule: any, value: any, callback: any) {
  if (value !== registerCardForm.password) {
    callback(new Error(i18n.global.t("cardRegister.errorPW")));
  } else {
    callback();
  }
}
